/*
 * VerticalLayout.js
 * Created on 1-9-2019
 * @author Swen Meeuwes for &ranj
 */

export default class VerticalLayout {
    constructor(container, spacing = 0) {
        this._container = container;
        this._spacing = spacing;
    }

    /**
     * Adds an item to the layout
     * @param {createjs.DisplayObject} item 
     * @param {number} index 
     * @param {Object} options 
     */
    addItem(item, index, options) {
        options = options || {};

        // Options
        const { preventPopulate } = options;

        // item must implement .getBounds(), make sure the children are populated (call .gotoAndStop() before hand)
        if (!preventPopulate && item.gotoAndStop) {
            item.gotoAndStop(0);
        }

        if (index !== undefined && index !== null) {
            this._container.addChildAt(item, index);
        } else {
            this._container.addChild(item);
        }
        this.repositionItems();
    }

    /**
     * Removes an item from the layout
     * @param {createjs.DisplayObject} item 
     */
    removeItem(item) {
        this._container.removeChild(item);
        this.repositionItems();
    }

    repositionItems() {
        if (this._container.gotoAndStop) {
            this._container.gotoAndStop(0);
        }

        var containerHeight = 0;
        for (var i = 0; i < this._container.children.length; i++) {
            let child = this._container.children[i];
            child.y = containerHeight;

            const childBounds = (child.getBounds() || child.nominalBounds);
            if (!childBounds) {
                continue;
            }

            containerHeight += childBounds.height + this._spacing;
        }
    }

    getBounds() {
        return this._container.getBounds();
    }
}